<template>
  <svg
    :class="['h-6 w-6 stroke-current', classes]"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M5.94118 14.459L1.90815 12.492C1.53611 12.3106 1.53306 11.7815 1.90298 11.5958L22.3661 1.3223C23.2201 0.893548 24.1314 1.7922 23.7146 2.65212L16.0421 18.4833C15.9215 18.7322 15.6216 18.8359 15.373 18.7146L10.138 16.1615C9.81907 16.006 9.44415 16.2228 9.41996 16.5768L9.24573 19.126C9.21079 19.6372 8.52097 19.7713 8.29712 19.3103L5.94118 14.459Z"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M8.875 19.8746L12.2503 17.2494"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M23.875 1.12457L10.375 11.2496"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
<script>
export default {
  props: {
    classes: {
      type: String,
      default: ""
    }
  }
}
</script>
